import React from "react";
import { withTranslation } from "react-i18next";
import APIErrorHelper from "../../../../../helpers/APIErrorHelper";
import CamplaCoreService from "../../../../../services/CamplaCoreService";
import { Col, Container, Row, Form } from "react-bootstrap";
import Switch from "react-switch";
import equals from "fast-deep-equal";
import BaseSelect from "../../../../../components/baseSelect/BaseSelect";
import JsonViewer from "../../../../../components/jsonViewer/JsonViewer";
import "./VMConfiguration.css";
import TabSection from "../tabSection/TabSection";
import MaschineSettingsSection from "./machineSettingsSection/MaschineSettingsSection";
import ValidationHelper from "../../../../../helpers/ValidationHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import SEBSettingsSection from "../generalSections/sebSettingsSection/SEBSettingsSection";

class VMConfiguration extends React.Component {
  constructor(props) {
    super(props);

    this.validationDefinition = {
      autostart: {
        defaultValue: ValidationHelper.isFieldDefined(
            this.props.examination.configuration,
            "autostart"
        )
            ? this.props.examination.configuration.autostart
            : false,
        initValid: true,
        rule: ValidationHelper.isBoolean,
      },
      start_password: {
        defaultValue: ValidationHelper.isFieldDefined(
          this.props.examination.configuration,
          "start_password"
        )
          ? this.props.examination.configuration.start_password
          : "",
        initValid: true,
        rule: ValidationHelper.isString,
      },
      connection_settings: {
        defaultValue: ValidationHelper.isFieldDefined(
          this.props.examination.configuration,
          "connection_settings"
        )
          ? this.props.examination.configuration.connection_settings
          : [],
        initValid: true,
        rule: ValidationHelper.isConnectionSetting,
      },
      vm_configuration: {
        defaultValue: ValidationHelper.isFieldDefined(
          this.props.examination.configuration,
          "vm_configuration"
        )
          ? this.props.examination.configuration.vm_configuration
          : { web_url: "", startup_applications: [] },
        initValid: true,
        rule: ValidationHelper.isVmConfig,
        converter: (value) => {
          try {
            return JSON.parse(value);
          }catch (err){
            return { web_url: "", startup_applications: [] };
          }
        },
      },
      lms_examination_key: {
        defaultValue: ValidationHelper.isFieldDefined(
          this.props.examination.configuration,
          "lms_examination_key"
        )
          ? this.props.examination.configuration.lms_examination_key
          : "",
        initValid: true,
        rule: ValidationHelper.isSHA256,
      },
      seb_configuration: {
        defaultValue: ValidationHelper.isFieldDefined(
          this.props.examination.configuration,
          "seb_configuration"
        )
          ? this.props.examination.configuration.seb_configuration
          : "",
        initValid: true,
        rule: ValidationHelper.isString,
      },
      quit_password: {
        defaultValue:
          ValidationHelper.isFieldDefined(
            this.props.examination.configuration,
            "quit_password"
          ) && this.props.examination.configuration.quit_password.length > 0
            ? this.props.examination.configuration.quit_password
            : (Math.random() + 1).toString(36).substring(8),
        initValid: true,
        rule: (value) => ValidationHelper.isString(value) && value.length > 0,
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      configuration: this.props.configuration,
      apiError: "",
      isOpen: false,
    };

    this.handleConfigurationUpdate = this.handleConfigurationUpdate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeURL = this.handleChangeURL.bind(this);
    this.handleSEBConfigurationDownload = this.handleSEBConfigurationDownload.bind(
      this
    );
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    }, () => {
      if (this.state.validation._isValid) {
        this.handleConfigurationUpdate();
      }
      this.props.onValid(this.state.validation._isValid);
    });
  }

  async handleSEBConfigurationDownload() {
    try {
      await CamplaCoreService.getExaminationSEBConfiguration(
        this.props.examination._id,
        `${this.props.examination.name}.seb`
      );
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  handleChangeURL(event) {
    const extractedValue = event.target.value;
    const {
      web_url,
      startup_applications,
      ...rest
    } = this.state.validation.vm_configuration.value;

    const newEventValue = {
      web_url: extractedValue,
      startup_applications: startup_applications,
      ...rest,
    };

    const newEvent = {
      target: { name: "vm_configuration", value: newEventValue },
    };

    this.setState({
      validation: ValidationHelper.update(newEvent, this.state.validation),
    });

    if (this.state.validation._isValid) this.handleConfigurationUpdate();
    this.props.onValid(this.state.validation._isValid);
  }

  handleConfigurationUpdate() {
    const configuration = ValidationHelper.getData(this.state.validation);
    const stringifiedVmConf = JSON.stringify(configuration.vm_configuration);

    const updatedConfiguration = { ...configuration, vm_configuration: stringifiedVmConf };

    this.setState({ configuration: updatedConfiguration });
    this.props.onUpdate(updatedConfiguration);
  }

  handleUpdate(remoteUpdate){
    const currentUpdate = ValidationHelper.getData(this.state.validation);
    const mergedUpdate = Object.assign( {}, currentUpdate, remoteUpdate);
    ValidationHelper.setData(this.state.validation, mergedUpdate);
    mergedUpdate["vm_configuration"] = JSON.stringify(mergedUpdate.vm_configuration);
    this.props.onUpdate(mergedUpdate);
  }

  componentDidMount() {
    let parsedVmConfig = this.state.validation.vm_configuration.value;
    if (typeof parsedVmConfig === "string") {
      try {
        parsedVmConfig = JSON.parse(parsedVmConfig);
      } catch (error) {
        console.error("Failed to parse vm_configuration value:", error);
      }
    }

    const newValidation = {
      ...this.state.validation,
      vm_configuration: {
        ...this.state.validation.vm_configuration,
        value: parsedVmConfig,
      },
    };

    this.setState({
      configuration: this.props.examination.configuration,
      validation: newValidation,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!equals(prevProps.configuration, this.props.configuration)) {
      this.setState({
        configuration: this.props.configuration,
        validation: ValidationHelper.updateAll(this.props.configuration, this.state.validation),
      });
    }
  }

  render() {
    const { t } = this.props;

    const options = [
      { value: [{ key: "bpp", value: "16" }], label: "High Color (16 bit)" },
      { value: [{ key: "bpp", value: "24" }], label: "True Color (24 bit)" },
      { value: [{ key: "bpp", value: "32" }], label: "Highest Quality (32 bit)" },
    ];

    return (
      <>
        <Container className="pl-0 pr-0">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}

          <TabSection
            openbydefault={true}
            title={t(
              "SingleExamination.ConfigurationTab.VmConfiguration.GeneralConf"
            )}
          >
            <Form.Group
              controlId="formStartPassword"
              style={{ marginBottom: "40px" }}
            >
              <Form.Label>
                {t(
                  "SingleExamination.ConfigurationTab.VmConfiguration.StartPassword"
                )}
              </Form.Label>
              <Form.Control
                type="text"
                name="start_password"
                disabled={
                  this.props.examination.status !== 1 &&
                  this.props.examination.status !== 50 &&
                  this.props.examination.status !== 51 &&
                  this.props.examination.status !== 52 &&
                  this.props.examination.status !== 53
                }
                value={this.state.validation.start_password.value}
                isInvalid={!this.state.validation.start_password.isValid}
                onChange={this.handleChange}
              />
              {this.state.validation.start_password.value.length < 1 ? (
                <Form.Text className="color-yellow">
                  <FontAwesomeIcon icon={faExclamationTriangle} />{" "}
                  {t(
                    "SingleExamination.ConfigurationTab.VmConfiguration.WarningNoStartPassword"
                  )}
                </Form.Text>
              ) : (
                ""
              )}
              <Form.Control.Feedback type="invalid">
                {t(
                  "SingleExamination.ConfigurationTab.VmConfiguration.ValidationError.StartPassword"
                )}
              </Form.Control.Feedback>
            </Form.Group>
          </TabSection>

          {this.props.examination.securityLevel >= 1 &&
          this.props.examination.securityLevel <= 4 ? (
            <TabSection
              title={t(
                "SingleExamination.ConfigurationTab.VmConfiguration.LernstickPropsTitle"
              )}
              description={t(
                "SingleExamination.ConfigurationTab.VmConfiguration.LernstickPropsDescription"
              )}
              bottomDivider={false}
            >
              <Form.Group controlId="formBasicModules">
                <Form.Label>
                  {t(
                    "SingleExamination.ConfigurationTab.VmConfiguration.BitsPerPixel"
                  )}
                </Form.Label>
                <BaseSelect
                  className="z-index-div"
                  isDisabled={this.props.examination.status !== 50}
                  options={options}
                  value={
                    options.find(
                      (option) =>
                        option.value[0].value ===
                        this.state.validation.connection_settings.value[0]
                          ?.value
                    ) || null
                  }
                  placeholder={t(
                    "SingleExamination.ConfigurationTab.VmConfiguration.DataBitsPlaceholder"
                  )}
                  onChange={(s) =>
                    this.handleChange({
                      target: {
                        name: "connection_settings",
                        value: s.value,
                      },
                    })
                  }
                />
                <Form.Control type="hidden" isInvalid={false} />
                <Form.Control.Feedback type="invalid">
                  {t("ModuleClasses.ModuleClassModal.ValidationError.ModuleId")}
                </Form.Control.Feedback>
              </Form.Group>
            </TabSection>
          ) : (
            ""
          )}
          {this.props.examination.securityLevel === 5 ||
          this.props.examination.securityLevel === 6 ? (
            <TabSection
              title={t(
                "SingleExamination.ConfigurationTab.VmConfiguration.SEBConf"
              )}
              description={t(
                "SingleExamination.ConfigurationTab.VmConfiguration.SEBDescription"
              )}
              bottomDivider={false}
            >
              <SEBSettingsSection
                disabled={
                  this.props.examination.status !== 1 &&
                  this.props.examination.status !== 50 &&
                  this.props.examination.status !== 51 &&
                  this.props.examination.status !== 52 &&
                  this.props.examination.status !== 53
                }
                onUpdate={this.handleUpdate}
                onSEBConfigurationDownload={this.handleSEBConfigurationDownload}
                onValid={this.props.onValid}
                isDirty={this.props.isDirty}
                securityLevel={this.props.examination.securityLevel}
                configuration={this.props.configuration}
                validation={this.state.validation}
              />
            </TabSection>
          ) : (
            ""
          )}
          <TabSection
            title={t(
              "SingleExamination.ConfigurationTab.VmConfiguration.MachineConf"
            )}
            description={t(
              "SingleExamination.ConfigurationTab.VmConfiguration.MachineConfDescription"
            )}
            bottomDivider={false}
          >
            <Form.Group controlId="formWebUrl" style={{ marginBottom: "40px" }}>
              <Form.Label>
                {t(
                  "SingleExamination.ConfigurationTab.VmConfiguration.FormWebURL"
                )}
              </Form.Label>
              <Form.Control
                type="text"
                name="vm_configuration"
                disabled={this.props.examination.status !== 50}
                value={this.state.validation.vm_configuration.value.web_url}
                isInvalid={
                  this.state.validation.vm_configuration.value.web_url?.length >
                    0 &&
                  !ValidationHelper.isUrl(
                    this.state.validation.vm_configuration.value.web_url
                  )
                }
                onChange={this.handleChangeURL}
              />
              <Form.Control.Feedback type="invalid">
                {t(
                  "SingleExamination.ConfigurationTab.VmConfiguration.ValidationError.WebUrl"
                )}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group style={{ marginBottom: "40px" }}>
              <Form.Label>
                {t(
                  "SingleExamination.ConfigurationTab.VmConfiguration.AutoStartApp"
                )}
              </Form.Label>
              <MaschineSettingsSection
                inputPlaceholder={t(
                  "SingleExamination.ConfigurationTab.VmConfiguration.InputPlaceholder"
                )}
                path={t(
                  "SingleExamination.ConfigurationTab.VmConfiguration.Path"
                )}
                invalidPath={t(
                  "SingleExamination.ConfigurationTab.VmConfiguration.ValidationError.InvalidPath"
                )}
                disabled={this.props.examination.status !== 50}
                instanceTemplateConfig={this.props.instanceTemplateConfig}
                validation={this.state.validation}
                onChange={(s) =>
                  this.handleChange({
                    target: {
                      name: "vm_configuration",
                      value: s.value,
                    },
                  })
                }
              />
            </Form.Group>

            <Form.Group style={{ marginBottom: "40px" }}>
              <Row>
                <Col className="d-flex align-items-center">
                  <Form.Label className="mb-0">
                    {t(
                      "SingleExamination.ConfigurationTab.VmConfiguration.AdvancedMachineConfig"
                    )}
                  </Form.Label>
                  <Switch
                    className="ml-auto"
                    onColor="#54BF8D"
                    height={18}
                    width={40}
                    checked={this.state.isOpen}
                    onChange={() => {
                      this.setState({ isOpen: !this.state.isOpen });
                    }}
                    disabled={this.props.examination.status !== 50}
                  />
                </Col>
              </Row>
            </Form.Group>
            {this.state.isOpen && (
              <>
                <p>
                  {t(
                    "SingleExamination.ConfigurationTab.VmConfiguration.AdvancedConfigDescription"
                  )}
                </p>
                <JsonViewer
                  content={this.state.validation.vm_configuration.value}
                  data={this.state.validation.vm_configuration.value}
                  handleUpdate={(s) =>
                    this.handleChange({
                      target: {
                        name: "vm_configuration",
                        value: s,
                      },
                    })
                  }
                />
              </>
            )}
          </TabSection>
        </Container>
      </>
    );
  }
}

export default withTranslation()(VMConfiguration);
